import Axios from 'axios'
const LOG_API_HOST = process.env.VUE_APP_LOG_API_HOST
const LOG_API_VERSION = process.env.VUE_APP_LOG_API_VERSION
const LoggerService = {
  /**
   * @description log user article log
   *
   * @returns {object}
   */
  logUserArticleAction(params) {
    const logURL = `${LOG_API_HOST}/${LOG_API_VERSION}/log/article`
    let paramsAry = [
      `article_id=${params.articleId}`, // required
      `article_session_id=${params.articleSessionId}`, // required
      `people_cookie_id=${params.peopleCookieId}`
    ]
    if (params.userId) {
      paramsAry.push(`user_id=${params.userId}`)
    }
    if (params.refer) {
      paramsAry.push(`refer=${params.refer}`)
    }
    if (params.agent) {
      paramsAry.push(`agent=${params.agent}`)
    }
    if (params.readRatio >= 0 && params.readRatio <= 100) {
      paramsAry.push(`read_ratio=${params.readRatio}`)
    }
    if (params.isSuggested) {
      paramsAry.push(`is_suggested=${params.isSuggested}`)
    }
    const paramsStr = paramsAry.join('&')
    return Axios.request({
      method: 'POST',
      url: logURL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      },
      data: paramsStr
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },

  /**
   * @description log user search log
   *
   * @returns {object}
   */
  logUserSearchAction(params) {
    const logURL = `${LOG_API_HOST}/${LOG_API_VERSION}/log/search`
    let paramsAry = [
      `people_cookie_id=${params.peopleCookieId}`,
      `keyword=${params.keyword}`
    ]
    if (params.userId) {
      paramsAry.push(`user_id=${params.userId}`)
    }
    if (params.refer) {
      paramsAry.push(`refer=${params.refer}`)
    }
    if (params.clickUrl) {
      paramsAry.push(`click_url=${params.clickUrl}`)
    }
    if (params.agent) {
      paramsAry.push(`agent=${params.agent}`)
    }
    if (params.trackId) {
      paramsAry.push(`track_id=${params.trackId}`)
    }
    if (params.playlistId) {
      paramsAry.push(`playlist_id=${params.playlistId}`)
    }
    const paramsStr = paramsAry.join('&')
    return Axios.request({
      method: 'POST',
      url: logURL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      },
      data: paramsStr
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },

  /**
   * @description log user listen log
   *
   * @returns {object}
   */
  logUserListenAction(params) {
    const logURL = `${LOG_API_HOST}/${LOG_API_VERSION}/log/listen`
    let paramsAry = [
      `people_cookie_id=${params.peopleCookieId}`, // required
      `track_id=${params.trackId}` // required
    ]
    if (params.userId) {
      paramsAry.push(`user_id=${params.userId}`)
    }
    if (params.scenarioId) {
      paramsAry.push(`scenario_id=${params.scenarioId}`)
    }
    if (params.playlistId) {
      paramsAry.push(`playlist_id=${params.playlistId}`)
    }
    if (params.refer) {
      paramsAry.push(`refer=${params.refer}`)
    }
    if (params.currentTime >= 0) {
      paramsAry.push(`current_time=${params.currentTime}`)
    }
    if (params.duration >= 0) {
      paramsAry.push(`duration=${params.duration}`)
    }
    if (params.agent) {
      paramsAry.push(`agent=${params.agent}`)
    }
    if (params.action) {
      paramsAry.push(`action=${params.action}`)
    }
    const paramsStr = paramsAry.join('&')
    return Axios.request({
      method: 'POST',
      url: logURL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      },
      data: paramsStr
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  }
}
export default LoggerService
